<template lang="html">
  <v-dialog 
    v-model="dialog" 
    persistent
    max-width="1050"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        color="info" 
        v-on="on"
      >
        Edit
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      title="User Company Access"
      color="green"
      text="Change User Company Access"
      class="mb-0"
    >
      <v-form v-if="!loading">
        <v-container>
          <v-row>
            <v-col
              cols="6"
              class="py-0"
            >
              <v-text-field
                v-model="searchCompany"
                label="Search company"
                prepend-icon="mdi-city"
              />
            </v-col>

            <v-col
              cols="6"
              class="py-0"
            >
              <v-text-field
                v-model="searchBranch"
                label="Search Branch"
                prepend-icon="mdi-city"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0">
              <v-row>
                <v-col cols="6">
                  <v-checkbox
                    v-model="selectAll"
                    class="mt-0 mx-2"
                    label="Select all (PERMANENT)"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="overflow">
            <v-col cols="12">
              <v-data-iterator
                :items="filteredItems"
                :hide-default-footer="true"
                disable-pagination
                item-key="name"
              >
                <template v-slot:default="companies">
                  <v-row>
                    <v-col
                      v-for="(company,index) in companies.items"
                      :key="index"
                      cols="12"
                      md="6"
                    >
                      <v-card>
                        <v-card-title class="py-0 ma-0">
                          <v-switch
                            v-model="company.is_active"
                            :label="company.name + (company.schema_name ? ' (' + company.schema_name + ')': '')"
                            text-lg-center
                          />
                        </v-card-title>

                        <v-divider />
                        <v-list
                          v-if="company.is_active"
                          dense
                        >
                          <v-list-item
                            v-for="branch in company.branches"
                            :key="branch.branch_name"
                          >
                            <v-card class="full-width">
                              <v-card-title>
                                <v-btn-toggle
                                  v-model="branch.is_active"
                                  @change="defaultDate(branch)"
                                >
                                  <v-btn
                                    class="px-0"
                                    small
                                    active-class="primary lighten-1"
                                  >
                                    <v-icon :color="branch.is_active === 0 ? 'white' : 'grey'">
                                      mdi-check-circle
                                    </v-icon>
                                  </v-btn>
                                  <v-btn
                                    class="px-0"
                                    small
                                    active-class="primary lighten-1"
                                  >
                                    <v-icon :color="branch.is_active === 1 ? 'white' : 'grey'">
                                      mdi-clock {{ branch.is_active == 1? 'mdi-spin':'' }}
                                    </v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                                <span class="ml-4 caption text-no-wrap text-truncate">{{ branch.branch_name }}</span>
                              </v-card-title>

                              <v-divider />

                              <v-list
                                v-if="branch.is_active"
                                class="py-0"
                              >
                                <v-list-item>
                                  <v-list-item-content class="py-0">
                                    <v-row>
                                      <v-col class="py-0">
                                        <v-menu
                                          v-model="branch.startMenu"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="290px"
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-text-field
                                              v-model="branch.tempStartDisplay"
                                              class="mt-4"
                                              label="Start Date"
                                              prepend-icon="event"
                                              readonly
                                              v-on="on"
                                            />
                                          </template>
                                          <v-date-picker
                                            v-model="branch.tempStart"
                                            no-title
                                            class="datepicker"
                                            :min="today"
                                            @change="branch.tempStartDisplay = formatDate(branch.tempStart);branch.tempStart > branch.tempEnd ? (branch.tempEnd = branch.tempStart) : (branch.tempEnd = branch.tempEnd);branch.tempEndDisplay = formatDate(branch.tempEnd)"
                                            @input="branch.startMenu = false"
                                          />
                                        </v-menu>
                                      </v-col>

                                      <v-col class="py-0">
                                        <v-menu
                                          v-model="branch.endMenu"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="290px"
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-text-field
                                              v-model="branch.tempEndDisplay"
                                              class="mt-4"
                                              label="End Date"
                                              prepend-icon="event"
                                              readonly
                                              v-on="on"
                                            />
                                          </template>
                                          <v-date-picker
                                            v-model="branch.tempEnd"
                                            no-title
                                            class="datepicker"
                                            :min="branch.tempStart"
                                            @change="branch.tempEndDisplay = formatDate(branch.tempEnd)"
                                            @input="branch.endMenu = false"
                                          />
                                        </v-menu>
                                      </v-col>
                                    </v-row>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-card>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-col>
          </v-row>          
        </v-container>
      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="loading"
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      userUid: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      dialog: null,
      loading: false,
      progressing: false,
      selectAll: false,

      levelOneLimit: 0,
      levelTwoLimit: 0,
      levelThreeLimit: 0,

      companies: [],
      searchCompany: '',
      searchBranch: '',

      today: new Date().toISOString().slice(0, 10), 
    }),
    computed: {
      filteredItems () {
        let _this = this
        let companies = [...this.companies]

        if (this.searchCompany) {                    
          companies = companies.filter(function (company) {
            return company.name.toLowerCase().indexOf(_this.searchCompany.toLowerCase()) !== -1
          })
        } 

        if (this.searchBranch) {          
          companies = companies.filter(function (company) {
            let branches = company.branches.filter(function (branch) {
              return branch.branch_name.toLowerCase().indexOf(_this.searchBranch.toLowerCase()) !== -1 
            })

            return branches.length > 0
          })
        }

        return companies.sort((a, b) => (a.name > b.name) ? 1 : -1)
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadInitalData()
        }
      },    
      selectAll (value) {
        if (value) {
          this.selectAllBranches()
        } else {
          this.unselectAllBranches()
        }
      },
    },
    methods: {  
      loadInitalData () {
        this.loading = true

        this.$api.companyBranches().list()
          .then((res) => {
            this.setBaseCompanyBranches(res.data)

            if (this.companies.length > 0) {
              this.resetBaseData()
            }

            this.$http.all([
              this.$api.userCompanies().list(this.userUid), 
              this.$api.approvalLimits().list(this.userUid),
              this.$api.userBranches().list(this.userUid),
              this.$api.userTempBranches().list(this.userUid),
            ])
              .then(this.$http.spread((companies, limits, branches, tempBranches) => {
                this.setUserCompanies(companies.data)
                this.setUserBranches(branches.data)
                this.setUserLimits(limits.data)              
                this.setUserTempBranches(branches.data, tempBranches.data)              

                this.loading = false
              }))
          })
      },
      submitForm () {
        this.setProgressing(true)
  
        this.$http.all([
          this.$api.userBranches().update(this.userUid, this.prepareBranchFormData()), 
          this.$api.userTempBranches().update(this.userUid, this.prepareTempBranchFormData()),
          this.$api.userCompanies().update(this.userUid, this.prepareCompanyFormData()), 
        ])
          .then(this.$http.spread((branchRes, tempBranchRes, companyRes) => {
            if (branchRes.status === 200 && companyRes.status === 200 && tempBranchRes.status === 200) {
              this.$api.approvalLimits().update(this.userUid, this.prepareApprovalLimitsData())
                .then(res => {
                  if (res.status === 200) {
                    this.$emit('updated')

                    this.dialog = false         
                  }                
                })            
            } 
          }))
          .catch(() => {})
          .then(() => {
            this.setProgressing(false)
          })
      },
      resetBaseData () {
        this.companies.forEach((company) => {
          company.is_active = false
          company.branches.forEach((branch) => {
            branch.is_active = false
          })
        })
      },    
      setBaseCompanyBranches (companies) {
        let t = JSON.parse(JSON.stringify(companies))
        t.forEach((company) => {
          company.is_active = false
          company.branches.forEach((branch) => {
            branch.is_active = false
          })
        })

        this.companies = t
      },
      setUserCompanies (companies) {
        let t = JSON.parse(JSON.stringify(companies))

        t.forEach((company) => {
          this.companies.forEach((c) => {
            if (c.id === company.id) {
              c.is_active = true
            }
          })
        })
      },
      setUserBranches (branches) {
        let t = JSON.parse(JSON.stringify(branches))

        this.companies.forEach((company) => {
          company.branches.forEach((branch) => {
            t.forEach((b) => {
              if (branch.branch_uid === b.branch_uid) {
                branch.is_active = 0
              }
            })
          })
        })
      },
      setUserLimits (limits) {
        limits.forEach((limit) => {
          if (limit.type === 'level 1 approval limit') {
            this.levelOneLimit = limit.upper_limit
          } else if (limit.type === 'level 2 approval limit') {
            this.levelTwoLimit = limit.upper_limit
          } else if (limit.type === 'level 3 approval limit') {
            this.levelThreeLimit = limit.upper_limit
          }
        })
      },
      setUserTempBranches (activeBranches, branches) {
        let t = JSON.parse(JSON.stringify(branches))
        let b = JSON.parse(JSON.stringify(activeBranches))
     
        t.forEach(tBranch => {
          b.forEach(bBranch => {
            if (tBranch.pivot.branch_uid === bBranch.branch_uid) {
              this.companies.forEach(company => {
                company.branches.forEach(branch => {
                  if (bBranch.pivot.branch_uid === branch.branch_uid) {
                    branch.tempStart = this.$moment(tBranch.pivot.start_date, 'YYYY-MM-DD  HH:mm:ss').format('YYYY-MM-DD')
                    branch.tempEnd = this.$moment(tBranch.pivot.end_date, 'YYYY-MM-DD  HH:mm:ss').format('YYYY-MM-DD')
                    branch.tempStartDisplay = this.formatDate(tBranch.pivot.start_date)
                    branch.tempEndDisplay = this.formatDate(tBranch.pivot.end_date)
                    branch.is_active = 1
                  }
                })
              })
            }
          })
        })
      },
      setProgressing (value = false) {
        this.progressing = value
      },
      prepareApprovalLimitsData () {
        return [
          {
            'type': 'level 1 approval limit',
            'upper_limit': this.levelOneLimit,
          },
          {
            'type': 'level 2 approval limit',
            'upper_limit': this.levelTwoLimit,
          },
          {
            'type': 'level 3 approval limit',
            'upper_limit': this.levelThreeLimit,
          },
        ]
      },
      prepareCompanyFormData () {
        return this.companies.map((company) => {
          return {
            id: company.id,
            is_active: company.is_active === true ? 1 : 0,
          }
        })
      },
      prepareBranchFormData () {
        let branches = []

        this.companies.map(company => {
          company.branches.map((branch) => {
            branches.push({
              id: branch.branch_uid,
              is_active: (company.is_active.toString() === 'false' || typeof (branch.is_active) === 'undefined') ? 0 : ((branch.is_active.toString() === 'false' || typeof (branch.is_active) === 'undefined') ? 0 : 1),
            })
          })
        })

        return branches
      },
      prepareTempBranchFormData () {
        let selected = []

        this.companies.map(company => {
          company.branches.map(branch => {
            if (branch.tempStart && branch.tempEnd) {
              selected.push({
                id: branch.branch_uid,
                start_date: this.$moment(branch.tempStart, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss'),
                end_date: this.$moment(branch.tempEnd, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss'),
              })
            }
          })
        })

        return selected
      },
      selectAllBranches () {
        this.companies.map(company => {
          company.is_active = true

          company.branches.map((branch) => {
            branch.is_active = 0
          })
        })
      },
      unselectAllBranches () {
        this.companies.map(company => {
          company.is_active = false

          company.branches.map((branch) => {
            branch.is_active = false
          })
        })
      },
      formatDate (date) {
        return this.$moment(date).format('DD/MM/YYYY')
      },
      defaultDate (selectedBranch) {
        this.companies.map(company => {
          company.branches.map(branch => {
            if (branch.branch_uid === selectedBranch.branch_uid && branch.is_active === 1) {
              branch.tempStart = this.$moment().format('YYYY-MM-DD')
              branch.tempEnd = this.$moment().format('YYYY-MM-DD')
              branch.tempStartDisplay = this.formatDate(branch.tempStart)
              branch.tempEndDisplay = this.formatDate(branch.tempEnd)
            }
          })
        })
      },
    },
  }
</script>

<style lang="css" scoped>
.overflow {
  overflow-y: scroll; 
  height: 50vh;
}
::v-deep .datepicker .v-btn{
  padding:0 !important;
  border-radius: 50%;
}
.full-width{
  width:100% !important;
}
</style>
